import store from '../store/store'
const Login = () => import('../views/Login')
const Panel = () => import('../views/Panel')
const Diagrams = () => import('../views/Panel/Diagrams')
const CookiesPolicy = () => import('../views/CookiesPolicy')
const PrivacyPolicy = () => import('../views/PrivacyPolicy')
const TermsOfService = () => import('../views/TermsOfService')
const Profile = () => import('../views/Profile')
const Subscription = () => import('../views/Subscription')
const Slides = () => import('../views/Panel/Slides')

async function setupFiltering (to, from, next) {
  if (to.query.category !== undefined) {
    store.commit('filtering/setCategory', parseInt(to.query.category))
  } else if (to.query.tag !== undefined) {
    store.commit('filtering/setTag', to.query.tag)
  }
  if (to.query.diagram !== undefined) {
    store.commit('filtering/setDiagram', to.query.diagram)
  }
  if (to.query.slide !== undefined) {
    store.commit('filtering/setSlide', to.query.slide)
  }
  if (to.query.search !== undefined) {
    store.commit('filtering/setQuery', to.query.search)
  }
  if (to.query.my === 'true') {
    store.commit('filtering/setMy', true)
  }
  next()
}

export default [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/panel',
    component: Panel,
    props: true,
    meta: { auth: true },
    beforeEnter: setupFiltering,
    children: [
      {
        default: true,
        path: 'diagrams/',
        component: Diagrams,
        name: 'diagrams'
      },
      {
        path: 'slides/',
        component: Slides,
        name: 'slides'
      }
    ]
  },
  {
    path: '/cookies-policy',
    name: 'cookies-policy',
    component: CookiesPolicy
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/subscription',
    name: 'subscription',
    component: Subscription
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy
  },
  {
    path: '/terms-of-services',
    name: 'terms-of-service',
    component: TermsOfService
  }
]
